import { createAction } from 'redux-actions';
import config from './config';

export const GET_PUBLIC_SITE_INFO = 'GET_PUBLIC_SITE_INFO';
export const getPublicSiteInfo = createAction(
    GET_PUBLIC_SITE_INFO, 
    subdomain => fetch(`${config.root}/groups/${subdomain}/public`)
                    .then(response => response.json()));

